import { FC } from 'react';

import { INode } from 'react-accessible-treeview';

import { AppRoutes } from 'constants/routes-paths.constants';
import { ColumnDefaultControls } from 'shared-components/table/ColumnDefaultControls';
import { TableData } from 'shared-components/table/TableData';
import { TableRow } from 'shared-components/table/TableRow';
import { getCommonRoutes } from 'utils/routes.utils';

interface Props {
  handleDelete: VoidFunction;
  parent?: INode;
  data: INode;
}

export const ProductGroupsTableRow: FC<Props> = ({ handleDelete, data: { id, name }, parent }) => {
  const { editRoute, viewRoute } = getCommonRoutes(AppRoutes.productGroups, +id);

  return (
    <TableRow>
      <TableData className='w-fit'>
        <ColumnDefaultControls
          handleDelete={handleDelete}
          editRoute={editRoute}
          viewRoute={viewRoute}
          editPermission='productGroups.update'
          deletePermission='productGroups.delete'
          viewPermission='productGroups.view'
        />
      </TableData>
      <TableData>{id}</TableData>
      <TableData className='last:text-left'>{name}</TableData>
      <TableData className='last:text-left'>{parent?.name}</TableData>
    </TableRow>
  );
};
